/**
 * 文档用户的 VIP 等级
 */

/**
 * 文档用户的 VIP 信息，value 为 Pick `vipcenter.proto` 协议中的 ItemInfo
 */

export var IVipSuperStatus = /*#__PURE__*/function (IVipSuperStatus) {
  IVipSuperStatus[IVipSuperStatus["NOT_YET"] = 1] = "NOT_YET";
  IVipSuperStatus[IVipSuperStatus["USING"] = 2] = "USING";
  IVipSuperStatus[IVipSuperStatus["EXPIRED"] = 3] = "EXPIRED";
  return IVipSuperStatus;
}({});
export var EVipStatus = /*#__PURE__*/function (EVipStatus) {
  EVipStatus[EVipStatus["NO_STATUS"] = 0] = "NO_STATUS";
  EVipStatus[EVipStatus["CLOSE"] = 1] = "CLOSE";
  EVipStatus[EVipStatus["OPEN"] = 2] = "OPEN";
  EVipStatus[EVipStatus["EXPIRED"] = 3] = "EXPIRED";
  return EVipStatus;
}({});
export var ExpiredStatus = /*#__PURE__*/function (ExpiredStatus) {
  ExpiredStatus[ExpiredStatus["EXPIRED"] = 1] = "EXPIRED";
  ExpiredStatus[ExpiredStatus["SUPER_VIP_EXPIRED"] = 2] = "SUPER_VIP_EXPIRED";
  return ExpiredStatus;
}({});
export var VipType = /*#__PURE__*/function (VipType) {
  VipType["NORMAL"] = "NORMAL";
  VipType["SUPER"] = "SUPER";
  VipType["SUPER_PLUS"] = "SUPER_PLUS";
  VipType["NONE"] = "NONE";
  VipType["EXPIRED"] = "EXPIRED";
  return VipType;
}({});
export var VipLevel = /*#__PURE__*/function (VipLevel) {
  VipLevel[VipLevel["NORMAL"] = 2] = "NORMAL";
  VipLevel[VipLevel["SUPER"] = 3] = "SUPER";
  VipLevel[VipLevel["SUPER_PLUS"] = 4] = "SUPER_PLUS";
  VipLevel[VipLevel["NONE"] = 1] = "NONE";
  VipLevel[VipLevel["EXPIRED"] = 0] = "EXPIRED";
  return VipLevel;
}({});
export var EUserVipType = /*#__PURE__*/function (EUserVipType) {
  EUserVipType[EUserVipType["NONE"] = 1] = "NONE";
  EUserVipType[EUserVipType["NORMAL"] = 2] = "NORMAL";
  EUserVipType[EUserVipType["SUPER"] = 3] = "SUPER";
  EUserVipType[EUserVipType["SUPER_PLUS"] = 4] = "SUPER_PLUS";
  return EUserVipType;
}({}); // 超级会员plus
export var EUserRenewalStatus = /*#__PURE__*/function (EUserRenewalStatus) {
  EUserRenewalStatus[EUserRenewalStatus["NONE"] = 0] = "NONE";
  EUserRenewalStatus[EUserRenewalStatus["AUTO_RENEWAL"] = 1] = "AUTO_RENEWAL";
  EUserRenewalStatus[EUserRenewalStatus["CLOSED"] = 2] = "CLOSED";
  return EUserRenewalStatus;
}({});
//# sourceMappingURL=vip-user-info.js.map